import { fetchFooter as fetchFooterService } from '@client/services/api/footer';

import types from './types';

export const openFeedbackDialog = () => ({
    type: types.OPEN_FEEDBACK_DIALOG
});

export const closeFeedbackDialog = () => ({
    type: types.CLOSE_FEEDBACK_DIALOG
});
export const showChatButton = () => ({
    type: types.SHOW_CHAT_BUTTON
});

export const hideChatButton = () => ({
    type: types.HIDE_CHAT_BUTTON
});

export const setFooter = (footer) => ({
    type: types.FETCH_FOOTER.SUCCESS,
    payload: { footer }
});

export const fetchFooter = () => async (dispatch) => {
    try {
        const footer = await fetchFooterService();
        if (Object.keys(footer).length > 0) {
            dispatch(setFooter(footer));
        }
    }
    catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
    }
};
